import Reveal from "./Reveal";
import WhatsAppIcon from "./WhatsAppIcon";
import { waLink } from "../config";

export default function Contact() {
  return (
    <section id="contact" className="relative bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-navy-900/8 bg-mist px-6 py-16 sm:px-12 md:py-20 lg:px-20">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-[radial-gradient(circle,rgba(37,99,235,0.10),transparent_65%)]"
          />
          <div className="relative max-w-2xl">
            <Reveal>
              <p className="eyebrow">Contact</p>
              <h2 className="font-display text-3xl font-light leading-tight text-navy-900 sm:text-4xl lg:text-[2.75rem]">
                Connect With Our Team
              </h2>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-navy-900/65 sm:text-lg">
                For business enquiries, service information or customized
                quotations, connect directly with our team.
              </p>
            </Reveal>
            <Reveal delay={0.12}>
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-button"
                className="btn-whatsapp mt-10"
              >
                <WhatsAppIcon className="h-5 w-5" />
                Connect on WhatsApp
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
